import { Injectable } from '@angular/core';
import { EntityService, HttpClient } from '@elotech/angular-common';
import { Observable, of } from 'rxjs';
import { HistoricoFuncionario } from "./historico-funcionario";
import { HistoricoFuncionarioDetailDTO } from "./historico-funcionario-detail-dto";

@Injectable()
export class HistoricoFuncionarioService extends EntityService<HistoricoFuncionario> {

  constructor(public httpClient: HttpClient) {
    super(httpClient);
    this.resource = '/api/historico-funcionario';
  }

  findHistoricoFuncionarioByFichaFinanceiraId(fichaFinanceiraId: string): Observable<HistoricoFuncionarioDetailDTO> {
    if (!fichaFinanceiraId) {
      return of();
    }

    return this.httpClient.get({
      resource: `${this.resource}?fichaFinanceiraId=${fichaFinanceiraId}`
    });
  }

  findByCompetenciaAndFuncionarioId(funcionarioId: number): Observable<HistoricoFuncionarioDetailDTO> {
    if (!funcionarioId) {
      return of();
    }

    return this.httpClient.get({
      resource: `${this.resource}/by-competencia-funcionario?funcionarioId=${funcionarioId}`,
      disableSpinner: true
    });
  }

  findByCompetenciaAndFuncionarioIdReduzido(funcionarioId: number): Observable<HistoricoFuncionarioDetailDTO> {
    if (!funcionarioId) {
      return of();
    }

    return this.httpClient.get({
      resource: `${this.resource}/by-competencia-funcionario-reduzido?funcionarioId=${funcionarioId}`,
      disableSpinner: true
    });
  }

}
